<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card no-header>
          <b-tabs @input='setTabIndex' justified>
            <b-tab title="Datos del Cliente" active>
              <b-table class="datos-objeto" 
                  responsive="sm" 
                  :busy="tableBusy"
                  :items="clienteDatos" 
                  :fields="fields">
                <template v-slot:cell(valor)="data">
                  {{ formattedData(data.item) }}
                </template>
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>              
              </b-table>
            </b-tab>

            <b-tab title="Observaciones">
              <b-form>
                <b-form-group>
                  <b-form-textarea
                    id="clienteObservaciones"
                    class="datos-observaciones"
                    :readonly= 'Boolean(true)'
                    :value= "clienteObservaciones" 
                    rows="50">
                  </b-form-textarea>
                </b-form-group>
              </b-form>
            </b-tab>

            <b-tab title="Contactos de Administración">
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :items="clienteContactosAdministracionDatos" 
                  :fields="contactosAdministracionFields">
                <template v-slot:cell(opciones)="data">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click.stop="editarContactoAdministracion(data.item)">
                      <i class="fa fa-edit"></i>Editar Datos del Contacto</b-dropdown-item>
                    <b-dropdown-item @click.stop="borrarContactoAdministracion(data.item)">
                      <i class="fa fa-edit"></i>Borrar Contacto</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Fee Rubros Diferenciados">
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :items="clienteRubrosTrabajosDatos" 
                  :fields="rubrosTrabajosFields">
                <template v-slot:cell(premios)="data">
                  {{ data.item.premios? 'Si' : 'No' }}
                </template>
                <template v-slot:cell(noAplicaFee)="data">
                  {{ data.item.noAplicaFee? 'Si' : 'No' }}
                </template>
                
                <template v-slot:cell(opciones)="data">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click.stop="editarRubroTrabajoCliente(data.item)">
                      <i class="fa fa-edit"></i>Editar Datos del Rubro</b-dropdown-item>
                    <b-dropdown-item @click.stop="borrarRubroTrabajoCliente(data.item)">
                      <i class="fa fa-edit"></i>Borrar Rubro</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Cliente</b-dropdown-item>

          <b-dropdown-item @click.stop="consultarContactos">
            <i class="fa fa-user"></i>Consultar Contactos</b-dropdown-item>

          <!--
          <b-dropdown-item @click.stop="consultarAcciones">
            <i class="fa fa-list"></i>Consultar Acciones</b-dropdown-item>
          -->      

          <b-dropdown-item @click.stop="agregarContactoAdministracion" 
              v-if="tabIndex == 2">
            <i class="fa fa-plus"></i>Agregar Contacto de Administración</b-dropdown-item>

          <b-dropdown-item @click.stop="agregarRubroTrabajoCliente" 
              v-if="tabIndex == 3">
            <i class="fa fa-plus"></i>Agregar Rubro de Trabajo</b-dropdown-item>

          <!--
          <b-dropdown-item @click.stop="agregarAccion" 
              v-if= 'tabIndex == 2'>
            <i class="fa fa-plus"></i>Agregar Acción</b-dropdown-item>

          <b-dropdown-item @click.stop="agregarContacto" 
              v-if= 'tabIndex == 3'>
            <i class="fa fa-plus"></i>Agregar Contacto</b-dropdown-item>
          -->

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="rubroTrabajoClienteModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM">
      <app-rubro-trabajo-cliente
        :clienteId="parseInt(id)"
        :rubroTrabajoClienteId="rubroTrabajoClienteId"
        @close="closeRubroTrabajoCliente">
      </app-rubro-trabajo-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>      
</template>

<script>
import RubroTrabajoCliente from '../rubrosTrabajosClientes/ABM';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cliente/getField',
  mutationType: 'cliente/updateField',
});

export default {
  name: 'ClientesData',
  components: {
    appRubroTrabajoCliente: RubroTrabajoCliente,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      id: 0,
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      /*
      accionesFields: [
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'inactivo',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      contactosFields: [
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'inactivo',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      */
      contactosAdministracionFields: [
        {
          key: 'cargo',
          sortable: true
        },
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'telefono',
          sortable: true
        },
        {
          key: 'email',
          sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      rubrosTrabajosFields: [
        {
          key: 'rubroTrabajo',
          sortable: true
        },
        {
          key: 'premios',
          label: 'Fee Diferenciado',
          class: 'text-center'

        },
        {
          key: 'noAplicaFee',
          class: 'text-center'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tabIndex: 0,
      
      tableBusy: false,

      contactoAdministracionSelected: null,
      rubroTrabajoClienteId: 0
    }
  },
  created() {
    this.id= this.$route.params.id

    this.getDatos();
  },  
  computed: {
    ...mapFields([
      'clienteDatos',
      'clienteObservaciones',
      /*
      'clienteAccionesDatos',
      'clienteContactosDatos',
      */
     'clienteContactosAdministracionDatos',
     'clienteRubrosTrabajosDatos'
    ]),
  },  
  methods: {
    getDatos() {
      this.tableBusy = true;
      this.$store.dispatch('cliente/getDatos', this.id)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    setTabIndex(e) {
      this.tabIndex = parseInt(e);
      //console.log(this.tabIndex);
    },
    goBack() {
      this.$router.push({ name: 'Clientes' });
    },
    editar() {
      this.$router.push({ name: 'ClienteABM', 
                          params: { id: this.id }});
    },
    /*
    consultarAcciones () {
      this.$router.push({ name: 'Acciones', 
                          params: { clienteId: this.id }});
    },
    */
    consultarContactos () {
      this.$router.push({ name: 'ClientesContactos', 
                          params: { clienteId: this.id }});
    },
    agregarContactoAdministracion() {
      this.$router.push({ name: 'ClienteContactoAdministracionABM', 
                          params: { clienteId: this.id,
                                    id: 0 }});
    },
    editarContactoAdministracion(item) {
      this.$router.push({ name: 'ClienteContactoAdministracionABM', 
                          params: { clienteId: this.id,
                                    id: item.id }});
    },
    borrarContactoAdministracion(item) {
      this.showModalConfirm('¿Desea borrar el contacto de administración seleccionado?', 
            this.borrarContacto.bind(this, item.id), 'Si', null, 'No')
    },
    borrarContacto(contactoAdministracionId){
      this.showSpinner();
      this.$store.dispatch('clientecontactoadministracion/delete', contactoAdministracionId)
        .then(() => this.showModalMsj('El contacto se borró con éxito', this.getDatos, this.getDatos, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    agregarRubroTrabajoCliente() {
      this.rubroTrabajoClienteId = 0;
      this.$refs.rubroTrabajoClienteModal.show();
    },
    editarRubroTrabajoCliente(item) {
      this.rubroTrabajoClienteId = item.id;
      this.$refs.rubroTrabajoClienteModal.show();
    },
    closeRubroTrabajoCliente() {
      this.$refs.rubroTrabajoClienteModal.hide();
      this.getDatos();
    },
    borrarRubroTrabajoCliente(item) {
      this.showModalConfirm('¿Desea borrar el rubro de la configuración del cliente?', 
            this.borrarRubroTrabajo.bind(this, item.id), 'Si', null, 'No')
    },
    borrarRubroTrabajo(rubroTrabajoClienteId){
      let params = {
        clienteId: this.id,
        rubroTrabajoClienteId
      }
      this.showSpinner();
      this.$store.dispatch('rubroTrabajoCliente/delete', params)
        .then(() => this.showModalMsj('El rubro se borró con éxito', this.getDatos, this.getDatos, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

  }
}
</script>

<style>
</style>